import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FormProvider, useForm } from 'react-hook-form';
import { debounce, isEmpty } from 'underscore';

import { fetchCountriesIfNeeded } from 'modules/countries';
import { getCountriesForSelect } from 'modules/countries/selectors';

import { fetchCities } from 'api/cities';
import { register } from 'api/users';

import RegisterTemplate from 'src/components/templates/Register/Register.jsx';

import formDataToRequest, { onSuccess } from './utils';

const Register = ({ assemblyId, role }) => {
    const [cities, setCities] = useState([]);
    const methods = useForm();
    const {
        setError,
        formState: { isSubmitting },
    } = methods;
    const countries = useSelector(getCountriesForSelect());
    const dispatch = useDispatch();

    const onSubmit = useCallback(
        formData => {
            if (isSubmitting) {
                return;
            }
            register({
                ...formDataToRequest(formData),
                role,
                hive: assemblyId || undefined,
            }).then(
                () => onSuccess(formData.email, formData.plainPassword, assemblyId),
                err => {
                    Object.entries(err?.body?.detail?.errors || {}).map(([fieldName, errors]) => {
                        !isEmpty(errors) && setError(fieldName, { message: errors.join('\n') });
                    });
                }
            );
        },
        [isSubmitting, assemblyId, setError]
    );

    const refreshCitySelect = debounce((country, zip) => {
        // don't search if one is "empty"
        if (!country || zip === '') {
            cities.length > 0 && setCities([]);
            return;
        }
        fetchCities({ zipCode: zip, country }).then(data =>
            setCities(
                data.cities.map(city => ({
                    label: city.name,
                    value: city.id.toString(),
                }))
            )
        );
    }, 300);

    useEffect(() => {
        dispatch(fetchCountriesIfNeeded());
    }, [dispatch]);

    return (
        <FormProvider {...methods}>
            <RegisterTemplate
                countries={countries}
                cities={cities}
                refreshCitySelect={refreshCitySelect}
                onSubmit={onSubmit}
            />
        </FormProvider>
    );
};

Register.propTypes = {
    assemblyId: PropTypes.string,
    role: PropTypes.string,
};
Register.defaultProps = {
    assemblyId: '',
};
export default Register;
